import { APIClient, getToken } from '@nielsen-media/ui-toolkit-vue-api';
import { EventBus } from '@nielsen-media/ui-toolkit-vue';

export default new APIClient(`${process.env.VUE_APP_OWL_URL}/v1`, getToken, EventBus);
